/**
 * Event Types and Constants for NodeTemplates System
 */

/**
 * Entity types in the system
 */
export type EntityType = 'NodeType' | 'NodeCategory' | 'NodeTemplate';

/**
 * Event actions
 */
export type EventAction =
  | 'FetchStarted'
  | 'FetchCompleted'
  | 'FetchFailed'
  | 'EnhancementStarted'
  | 'EnhancementCompleted'
  | 'Ready';

/**
 * Event detail payload structure
 */
export interface NodeTemplateEventDetail<T = any> {
  /** The entity type involved in the event */
  entityType: EntityType;
  /** The action being performed */
  action: EventAction;
  /** Optional data payload */
  data?: T;
  /** Optional error if the action failed */
  error?: Error;
  /** Timestamp of the event */
  timestamp: string;
}

/**
 * Event name constants
 * Format: NodeTemplates:{EntityType}:{Action}
 */
export const EVENT_NAMES = {
  // NodeType events
  NODE_TYPES_FETCH_STARTED: 'NodeTemplates:NodeTypes:FetchStarted',
  NODE_TYPES_FETCH_COMPLETED: 'NodeTemplates:NodeTypes:FetchCompleted',
  NODE_TYPES_FETCH_FAILED: 'NodeTemplates:NodeTypes:FetchFailed',

  // NodeCategory events
  NODE_CATEGORIES_FETCH_STARTED: 'NodeTemplates:NodeCategories:FetchStarted',
  NODE_CATEGORIES_FETCH_COMPLETED: 'NodeTemplates:NodeCategories:FetchCompleted',
  NODE_CATEGORIES_FETCH_FAILED: 'NodeTemplates:NodeCategories:FetchFailed',

  // NodeTemplate events
  TEMPLATES_FETCH_STARTED: 'NodeTemplates:Templates:FetchStarted',
  TEMPLATES_FETCH_COMPLETED: 'NodeTemplates:Templates:FetchCompleted',
  TEMPLATES_FETCH_FAILED: 'NodeTemplates:Templates:FetchFailed',
  TEMPLATES_ENHANCEMENT_STARTED: 'NodeTemplates:Templates:EnhancementStarted',
  TEMPLATES_ENHANCEMENT_COMPLETED: 'NodeTemplates:Templates:EnhancementCompleted',
  TEMPLATES_READY: 'NodeTemplates:Templates:Ready',
} as const;

/**
 * Type for event names
 */
export type EventName = typeof EVENT_NAMES[keyof typeof EVENT_NAMES];
